'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCurrentBoardId = exports.getIsCurrentBoardIdInitialised = undefined;

var _currentBoardIdConstants = require('./currentBoardIdConstants');

var getIsCurrentBoardIdInitialised = exports.getIsCurrentBoardIdInitialised = function getIsCurrentBoardIdInitialised(state) {
    return state.getIn(['app', 'currentBoardId']) !== _currentBoardIdConstants.UNINITIALISED;
}; // Constants
var getCurrentBoardId = exports.getCurrentBoardId = function getCurrentBoardId(state) {
    return getIsCurrentBoardIdInitialised(state) ? state.getIn(['app', 'currentBoardId']) : null;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/currentBoardId/currentBoardIdSelector.js
// module id = 306
// module chunks = 0